import { HOCS_STATE_KEY } from "~/hocs";
import { REQUEST_IDS_STATE_KEY } from "./reducer";

const _getModuleState = (state) => state[HOCS_STATE_KEY][REQUEST_IDS_STATE_KEY];

export const getRequestIds = (state) => _getModuleState(state);
